export const DEV_ID_STORAGE_KEY = "coval.devId"
export const RUNS_FILTER_STORAGE_KEY = "runs-page-filters"
